import React from "react";
import './Loading.scss'
import { ProgressDots } from "./_components/ProgressDots/ProgressDots";

const Loading = () => {

    return (



        <div className="containerLoading">
            <div className="card is-loading-Loading">

                <div className="main">
                    <div className="col-12">
                        <div className="image"> </div>
                    </div>
                    <div className="container-fluid">
                        <div className="row layout">
                            <div id="anchor"></div>
                            <div className="col-12 col-xl-9 left">
                                <br /><br /><br /><br /><br />
                                <p style={{ width: '660px' }}></p>
                                <h2 style={{ width: '500px' }}></h2>
                                <h2 style={{ width: '400px' }}></h2>
                                <h2 style={{ width: '300px' }}></h2>
                                <h2 style={{ width: '500px' }}></h2>
                                <h2 style={{ width: '400px' }}></h2>
                                <h2 style={{ width: '300px' }}></h2>
                                <h2 style={{ width: '500px' }}></h2>
                                <h2 style={{ width: '400px' }}></h2>
                                <h2 style={{ width: '300px' }}></h2>

                            </div>
                            <div className="col-12 col-xl-3 attachments">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        // <div className="page has-sidebar-Loading">
        //     <header className="page-header-Loading">
        //         Header
        //     </header>

        //     <aside className="page-aside-Loading">
        //         Aside
        //     </aside>

        //     <main className="page-main-Loading">
        //         <div className="card is-loading-Loading">

        //   </div>
        //     </main>

        //     <footer className="page-footer-Loading">
        //         Footer
        //     </footer>
        // </div>

        // <div classNameName="containerLoading">
        //     <div classNameName="card is-loading">
        //         <div classNameName="image"></div>
        //         <div classNameName="content">

        //             <p style={{ width: '400px' }}></p>
        //             <blockquote /><h2 style={{ width: '500px' }}></h2>
        //             <h2 style={{ width: '300px' }}></h2>
        //             <h2 style={{ width: '300px' }}></h2>
        //             <h2 style={{ width: '400px' }}></h2>
        //             <h2 style={{ width: '300px' }}></h2>

        //         </div>

        //     </div>
        //     <div classNameName="image"></div>
        // </div>

    );
};

export default Loading;